import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { logger } from 'redux-logger'
import firebase from 'firebase/app'
import 'firebase/auth'

import { Platform } from 'react-native'
import rootReducer from './reducers'

const isWeb = Platform.OS === 'web'

const middleware = [thunk]
if (__DEV__ && isWeb) middleware.push(logger)

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const enhancers = composeEnhancers(applyMiddleware(...middleware))

// const persistedReducer = persistReducer(persistConfig, rootReducer)
const configureStore = () => createStore(rootReducer, enhancers)
const store = configureStore()

const fb = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
}

if (!firebase.apps.length) {
  firebase.initializeApp(fb)
} else {
  firebase.app() // if already initialized, use that one
}

export default configureStore
export { store }
